
class SearchSuggestions extends HTMLElement {
    constructor() {
      super();
      this.screenWidth = screen.width;
      this.searchIcon;
      if (this.screenWidth > 768) {
        this.searchIcon = document.querySelector('a.show-search-link.desktop-only');
      }
      else{
        this.searchIcon = document.querySelector('a.show-search-link.mobile-only');
      }
      this.allSearchInputs  = document.querySelectorAll('input.main-search__input');
      this.input  = document.querySelector('input.main-search__input:first-child');
      this.searchResults = document.getElementById('main-search');
      this.searchInputActive()

      this.body = document.body;
      this.debouncedOnSearchIconClick = debounce((event) => {
        this.searchMenuFullWidthOpen(event);
      });

      this.debouncedOnSearchInputClick = debounce((event) => {
        this.searchSuggestionsOpen(event);
      });

      this.mainSearchResults = document.querySelectorAll('#main-search.main-search--has-results')
      this.searchIcon?.addEventListener('click', this.debouncedOnSearchIconClick.bind(this));

    }

    searchInputActive(){
        var observer = new IntersectionObserver(function(entries) {
          if(entries[0].isIntersecting === true){
            entries[0].target.classList.add('main-input__active');
          }
        }, { threshold: [1] });

        const allSearchInputs = [...this.allSearchInputs];
        allSearchInputs.forEach(function(node) {
          observer.observe(node);
        });
        
    }
    
    searchMenuFullWidthOpen() {
      const mainSearch = document.getElementById('main-search')
      mainSearch.setAttribute("fullWidth", "true" )
    }

    searchSuggestionsOpen() {
        this.searchContainer = document.querySelector('.main-search__container:not(.ipad-only)');
        this.searchResults = this.searchContainer.querySelector('.main-search__results');
        this.searchResultsWrapper = document.createElement('div');
        this.searchResultsWrapper.className = "main-search__results-wrapper"
        this.searchResults.parentNode.insertBefore(this.searchResultsWrapper, this.searchResults);
        this.searchResultsWrapper.appendChild(this.searchResults);
    }


}

customElements.define('main-search__input', SearchSuggestions);

document.addEventListener("DOMContentLoaded", function(event) { 
  const search = new SearchSuggestions;
});
